import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { Dialog, DialogContent } from "@b2bportal/core-ui";
import { useDeviceType } from "@b2bportal/core-utilities";
import { FlightSearch, useFlightShopSearch } from "@tenant/flights";
import styles from "./styles.module.scss";

interface FlightShopSearchProps {
  onSearch: () => void;
  onClose: () => void;
}

export const FlightShopSearch: React.FC<FlightShopSearchProps> = ({
  onSearch: onSearchCallback,
  onClose: onCloseCallback,
}) => {
  const { isDesktopAndUp } = useDeviceType();
  const [, cn] = useModuleBEM(styles, CoreFlightsComponent.FlightShopSearch);

  const {
    context: { openCalendar },
    handlers: { onClose, handleOnSearch },
  } = useFlightShopSearch();

  return isDesktopAndUp ? (
    <FlightSearch />
  ) : (
    <div>
      <Dialog
        open={true}
        onClose={() => {
          onClose();
          onCloseCallback();
        }}
      >
        <DialogContent fullScreen={true}>
          <FlightSearch
            className={cn("search", { calendar: openCalendar })}
            onSearch={() => {
              handleOnSearch();
              onSearchCallback();
            }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};
